import React from 'react';
import { Field } from 'formik';
import { RenderTextField } from './FormikElements';
const NonNegativeNumberField = ({
  name,
  error,
  disableStepper = false,
  allowDecimal = false,
}) => {
  return (
    <Field
      name={name}
      component={RenderTextField}
      type='number'
      min={0}
      error={error}
      onKeyDown={(e) => {
        if (e.key === '-' || e.key === 'e' || e.key === '+') {
          e.preventDefault();
        }
        if (!allowDecimal && e.key === '.') {
          e.preventDefault();
        }
        //disable arrow keys
        if (disableStepper && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
          e.preventDefault();
        }
      }}
      isStepperDisabled={disableStepper}
    />
  );
};

export default NonNegativeNumberField;
